import React from 'react';
// @ts-ignore
import DHTypography from "@digital-hig/mui/Typography";
// @ts-ignore
import DHBox from "@digital-hig/mui/Box";
import { ResourceItem } from '../../typings/home';

interface ResourcesSectionProps {
  title?: string;
  resources: ResourceItem[];
}

export const ResourcesSection: React.FC<ResourcesSectionProps> = ({ 
  title = "Resources", 
  resources 
}) => {
  return (
    <DHBox sx={{ 
      textAlign: 'left', 
      height: '165px',
      width: { xs: '100%', sm: '100%', md: '100%', lg: '360px', xl: '360px' },
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      gap: { xs: 2, sm: 2, md: 2, lg: 0, xl: 0 }
    }}>
      {/* Resources Title */}
      <DHBox sx={{ 
        textAlign: 'left', 
        height: { xs: 'auto', sm: 'auto', md: 'auto', lg: '26px', xl: '26px' },
        width: { xs: '100%', sm: '100%', md: '100%', lg: '360px', xl: '360px' },
        display: 'flex',
        alignItems: 'center'
      }}>
        <DHTypography 
          variant="headline-small" 
          component="h3" 
          gutterBottom 
          sx={{
            fontFamily: 'Artifakt Element',
            fontWeight: 700,
            fontSize: { xs: '18px', sm: '20px', md: '21px', lg: '21px', xl: '21px' },
            lineHeight: '125%',
            letterSpacing: '0%'
          }}
        >
          {title}
        </DHTypography>
      </DHBox>

      {/* Resources List */}
      {resources.map((resource) => (
        <DHBox key={resource.id} sx={{ 
          textAlign: 'left', 
          height: { xs: 'auto', sm: 'auto', md: 'auto', lg: '26px', xl: '26px' },
          width: { xs: '100%', sm: '100%', md: '100%', lg: '360px', xl: '360px' },
          display: 'flex',
          alignItems: 'center'
        }}>
          <DHTypography variant="headline-small" component="h3">
            <a
              href={resource.link}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'underline', color: '#000000' }}
            >
              <DHTypography 
                variant="caption" 
                sx={{
                  fontFamily: 'Artifakt Element',
                  fontWeight: 400,
                  fontSize: '16px',
                  lineHeight: '150%',
                  letterSpacing: '0%',
                  textAlign: 'center',
                  color: '#000000'
                }}
              >
                {resource.title}
              </DHTypography>
            </a>
          </DHTypography>
        </DHBox>
      ))}
    </DHBox>
  );
};

